import crudGeneric from './crud/crud'

export * from './service'
export {
    crudGeneric
}
